module.exports = __webpack_public_path__ + "img/logo.e481c114.png";